import { render, staticRenderFns } from "./PptMetadata.vue?vue&type=template&id=3acbb1b0&"
import script from "./PptMetadata.vue?vue&type=script&lang=js&"
export * from "./PptMetadata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/PptMetadata.vue"
export default component.exports